import _it from './it.json';
import _en from './en.json';

export const it = _it;
export const en = _en;
